module.exports = __webpack_public_path__ + "static/book_04-960x550-729fbd1411e69edc4280a9c8860a821f.jpg";